import React from 'react'
import { FaDatabase } from 'react-icons/fa'
import PillsDataset from '../../../PillsDataset'
import { StepCard, StepHeader, StepContent, SourceGroup } from '../ModelPerformanceCard.styles'

interface DataSourcesCardProps {
  gradients: {
    metrics: string
  }
  trainingDataSources: string[]
  validationDataSources: string[]
  trainingTagNames?: string[]
  validationTagNames?: string[]
}

const DataSourcesCard: React.FC<DataSourcesCardProps> = ({
  gradients,
  trainingDataSources,
  validationDataSources,
  trainingTagNames = [],
  validationTagNames = [],
}) => {
  return (
    <StepCard>
      <StepHeader $gradient={gradients.metrics}>
        <FaDatabase />
        Data Sources
      </StepHeader>
      <StepContent>
        <SourceGroup>
          <div className="source-label">Training Dataset</div>
          <div className="dataset-container">
            <PillsDataset datasetNames={trainingDataSources} tiny={false} />
          </div>
          {trainingTagNames.length > 0 && (
            <div className="dataset-container" style={{ marginTop: '0.5rem' }}>
              <div className="source-label" style={{ marginBottom: '0.25rem' }}>
                Selected Tags
              </div>
              <PillsDataset datasetNames={trainingTagNames} tiny={false} />
            </div>
          )}
        </SourceGroup>
        <SourceGroup style={{ marginBottom: 0 }}>
          <div className="source-label">Validation Dataset</div>
          <div className="dataset-container">
            <PillsDataset datasetNames={validationDataSources} tiny={false} />
          </div>
          {validationTagNames.length > 0 && (
            <div className="dataset-container" style={{ marginTop: '0.5rem' }}>
              <div className="source-label" style={{ marginBottom: '0.25rem' }}>
                Selected Tags
              </div>
              <PillsDataset datasetNames={validationTagNames} tiny={false} />
            </div>
          )}
        </SourceGroup>
      </StepContent>
    </StepCard>
  )
}

export default DataSourcesCard
